import React from 'react';
export function Footer() {
  return <footer className="bg-sage-800 text-sage-100/60 py-12 text-center" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <h3 className="font-serif text-2xl text-cream mb-6" data-id="element-64">
          Vuelve a Sentirte Tú
        </h3>

        <div className="flex flex-wrap justify-center gap-6 text-sm mb-8" data-id="element-65">
          <a href="#" className="hover:text-cream transition-colors" data-id="element-66">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-67">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-68">
            Contacto
          </a>
        </div>

        <p className="text-xs" data-id="element-69">
          &copy; {new Date().getFullYear()} Vuelve a Sentirte Tú. Todos los
          derechos reservados.
        </p>
        <p className="text-xs mt-2 max-w-2xl mx-auto opacity-50" data-id="element-70">
          Este producto no sustituye el consejo médico profesional. Consulte a
          su médico antes de comenzar cualquier programa de nutrición o
          suplementación.
        </p>
      </div>
    </footer>;
}